import { render, staticRenderFns } from "./ProductPurchase.vue?vue&type=template&id=6514e96f&"
import script from "./ProductPurchase.vue?vue&type=script&lang=js&"
export * from "./ProductPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ProductPurchase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports